import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { Printer, Award } from 'lucide-react';

export default function Certificate() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get('/progress/stats').then(r => setStats(r.data)).catch(()=>{}); }, []);

  const isComplete = stats?.is_complete;

  return (
    <div className="kc-container py-10 md:py-14 max-w-3xl">
      <div className="flex items-center justify-between mb-6 print:hidden">
        <div>
          <div className="text-[11px] tracking-[0.18em] uppercase text-muted-kc">Certificate</div>
          <h1 className="font-display uppercase text-3xl md:text-4xl mt-1">Of completion</h1>
        </div>
        <button onClick={() => window.print()} disabled={!isComplete} className="h-11 px-5 inline-flex items-center gap-2 rounded-[var(--kc-radius-sm)] bg-ink text-white font-semibold hover:bg-black/90 transition-colors disabled:opacity-40" data-testid="certificate-print"><Printer size={16}/> Print</button>
      </div>

      {!isComplete ? (
        <div className="bg-white border border-kc rounded-[var(--kc-radius-md)] p-8 text-center">
          <Award className="text-muted-kc mx-auto" size={48} />
          <div className="font-display uppercase text-2xl mt-3">Not yet complete</div>
          <p className="text-muted-kc mt-2">Finish all lessons in HEADSPACE to unlock your certificate.</p>
          <Link to="/courses/headspace" className="mt-4 inline-flex h-11 px-5 items-center rounded-[var(--kc-radius-sm)] bg-[color:var(--kc-gold)] text-black font-semibold">Continue learning</Link>
        </div>
      ) : (
        <div className="bg-white relative" data-testid="certificate-doc">
          <div className="border-[12px] border-ink p-8 md:p-12 relative">
            <div className="absolute inset-3 border-2 border-gold pointer-events-none" />
            <div className="relative text-center">
              <div className="text-[11px] tracking-[0.32em] uppercase text-gold">Kickass Course</div>
              <div className="mt-1 text-[11px] tracking-[0.18em] uppercase text-muted-kc">Certificate of Completion</div>
              <Award className="text-gold mx-auto mt-4" size={48} />
              <div className="font-display uppercase text-4xl md:text-6xl mt-4 leading-[0.9]">This certifies that</div>
              <div className="font-display uppercase text-4xl md:text-6xl mt-3 text-gold leading-[0.9]">{user?.name}</div>
              <div className="font-display uppercase text-2xl md:text-3xl mt-6">has completed the course</div>
              <div className="font-display uppercase text-3xl md:text-5xl mt-2">HEADSPACE</div>
              <div className="text-muted-kc text-sm mt-2 italic">Master Your Mind or It Will Master You</div>
              <div className="mt-8 grid grid-cols-2 gap-4 max-w-md mx-auto text-xs uppercase tracking-wider">
                <div>
                  <div className="text-muted-kc">Date</div>
                  <div className="mt-1 font-semibold">{new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</div>
                </div>
                <div>
                  <div className="text-muted-kc">Instructor</div>
                  <div className="mt-1 font-semibold">Mickey Trivett</div>
                </div>
              </div>
              <div className="mt-8 text-[11px] tracking-[0.32em] uppercase">Live Life. <span className="text-gold">Do Good.</span> Be Happy.</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
